export default "__VITE_ASSET__B83jcHFr__"